import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionSurpriseColorIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <circle cx="8.208" cy="8" r="8" fill="#FA3" />
    <path
      fill="#323232"
      fillRule="evenodd"
      d="M13.54 4.934c0 .885-.714 1.6-1.6 1.6-.885 0-1.6-.715-1.6-1.6 0-.885.715-1.6 1.6-1.6.886 0 1.6.715 1.6 1.6Zm-7.466 0c0 .885-.715 1.6-1.6 1.6-.885 0-1.6-.715-1.6-1.6 0-.885.715-1.6 1.6-1.6.885 0 1.6.715 1.6 1.6Zm2.133 9.067c1.179 0 2.134-1.194 2.134-2.667 0-1.473-.955-2.667-2.134-2.667-1.178 0-2.133 1.194-2.133 2.667 0 1.473.955 2.667 2.133 2.667Z"
      clipRule="evenodd"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.874 3.334h10.667v10.667H2.874z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionSurpriseColorIcon);
